// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2gjrI","content":"RecentSearches_content__22YFp"};